<template>
  <v-app>
    <template>
      <v-container fluid>

        <v-row justify="center">
          <v-col md="12" xs="12" sm="12">
            <router-view></router-view>
          </v-col>
        </v-row>
        <!-- <v-row justify="center">
          <v-img max-height="8%" max-width="100%" src="../images/background_bottom.jpg"
            :style="{ objectFit: 'cover', objectPosition: 'top' }"></v-img>
        </v-row> -->
      </v-container>
    </template>
  </v-app>
</template>


<script>

export default {
  name: "App",
  components: {
  },
  data: () => ({
  }),
  mounted() {
    console.log(this.$vuetify.breakpoint.name);
  },
  computed: {
    headingFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "45px";
        case "sm":
          return "60px";
        case "md":
          return "65px";
        case "lg":
          return "65px";
        case "xl":
          return "70px";
      }
    },
    backgroundSizePercentage() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "160%";
        case "sm":
          return "150&";
        case "md":
          return "100%";
        case "lg":
          return "100%";
        case "xl":
          return "100%";
      }
    },
  },
};
</script>

<style scoped>
.v-image__image--contain {
  background-position: top !important;
}

#app {
  /* background-image: url("../images/DavidHannahbackground1264x1904.jpg"); */
  /* background-image: url("../images/background_top.jpg");
  background-repeat: no-repeat; */
  /* background-size: 60% 300px; */
  /* background-position: center top; */
  background-color: white;
  /* position: fixed; */
  /* top: 0; */
  /* left: 0; */

  /* Preserve aspect ratio */
  /* min-width: 100%; */
  /* min-height: 50%; */

  /* background-attachment:fixed; */
  /* -webkit-background-size:cover; */
  /* background-repeat: center top fixed; */
  /* background-size: 100%; */
  /* background-position-x: 0, center; */
  /* background-position-y: 100%, center; */
}

/* .mainText {
  margin-bottom: -100px;
} */

#main-flower {
  padding-bottom: -10em;
  margin-bottom: -50px;
  /* position: absolute; */
  /* background-position: top; */

}

#main-text {
  margin-top: 140px;
  /* background-position: top; */
}


.heading-1 {
  font-family: "Bacalisties";
  /* font-size: 300%; */
  color: #0f433b;
}

.details {
  margin-top: -800px;
  /* margin: 1vmin; */
  /* font-size: 18px; */
  font-size: 1rem;
  font-family: "Questa Grande";
}

@font-face {
  font-family: "Lambresia";
  src: local("Lambresia"), url(./fonts/lambresia.otf) format("opentype");
}

@font-face {
  font-family: "KievitOT";
  src: local("KievitOT"), url(./fonts/KievitOT-Regular.otf) format("opentype");
}

@font-face {
  font-family: "Questa Grande";
  src: local("Questa Grande"), url(./fonts/2-Questa_Grande_Regular.otf) format("opentype");
}

@font-face {
  font-family: "Bacalisties";
  src: local("Bacalisties"), url(./fonts/Bacalisties.ttf) format("opentype");
}
</style>
